/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Varnish = ({ color = 'primary', aspectRatio = '797/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Varnish" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Varnish, Varnish as default };
